module.exports = __webpack_public_path__ + "img/mobileladdercontrol2.d08a0543.png";